import { useState, useEffect, useRef } from "react";
import userStore from "../../store/userStore";
import { toast } from "react-toastify";
import axios from "axios";
import GiphyModal from "./GiphyModal";
import { useRouter } from "next/navigation";
import Link from "next/link";
import { MdCameraAlt, MdClose, MdInfoOutline } from "react-icons/md";
import TenorModal from "./TenorModal";

export default function FormCommentaires({
  children,
  passRefresh,
  passHideReponseForm,
  ...props
}) {
  const router = useRouter();

  const userPseudo = userStore.getState().userPseudo;
  const userAvatar = userStore.getState().userAvatar;
  const [avatar, setAvatar] = useState(false);
  const [pseudo, setPseudo] = useState(false);

  useEffect(() => {
    setAvatar(userAvatar);
    setPseudo(userPseudo);
  }, [userAvatar, userPseudo]);

  const [giphyId, setGiphyId] = useState(null);
  const [giphySlug, setGiphySlug] = useState(null);
  const [showGiphyModal, setShowGiphyModal] = useState(false);
  const [tenorId, setTenorId] = useState(null);
  const [tenorSlug, setTenorSlug] = useState(null);
  const [showTenorModal, setShowTenorModal] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [texte, setTexte] = useState(
  //   props?.id_reponse && props.id_reponse > 0
  //     ? "@" + props.pseudo_reponse + ": "
  //     : ""
  // );
  const [texte, setTexte] = useState("");
  // const [texte, setTexte] = useState("");
  const [nsfw, setNsfw] = useState(0);
  const [fichier, setFichier] = useState(null);
  const [fichierPreview, setFichierPreview] = useState(null);
  const [pourcentage, setPourcentage] = useState(0);
  const [urlMedia, setUrlMedia] = useState(null);

  useEffect(() => {
    if (giphyId && giphySlug)
      setUrlMedia("https://giphy.com/gifs/" + giphySlug + "-" + giphyId);
    else setUrlMedia(null);
  }, [giphyId, giphySlug]);

  useEffect(() => {
    if (tenorId && tenorSlug) {
      setUrlMedia(tenorSlug);
      console.log("tenorId", tenorId);
      console.log("urlMedia", tenorSlug);
    } else setUrlMedia(null);
  }, [tenorId, tenorSlug]);

  // si c'est le formulaire de réponse, on focus le textarea
  const refTextarea = useRef(null);
  useEffect(() => {
    if (props.id_reponse && props.id_reponse > 0) {
      // Get the current value of the textarea
      const textareaValue = refTextarea.current.value;

      // Find the position of the word "example" in the textarea
      const position = textareaValue.indexOf(texte);

      // If the word "example" is found, set the cursor position to the end of the word
      if (position !== -1) {
        refTextarea.current.selectionStart = position + texte.length;
        refTextarea.current.selectionEnd = position + texte.length;
      }

      refTextarea.current.focus();
    }
  }, [props.id_reponse, refTextarea]);

  // poster
  const poster = async () => {
    setLoading(true);

    var bodyFormData = new FormData();
    bodyFormData.append("user_agent", "Choualbox Next");
    bodyFormData.append("token", props.userTk);
    bodyFormData.append("texte", texte);
    bodyFormData.append("nsfw", nsfw);
    if (fichier) {
      bodyFormData.append("image", fichier);
    } else if (urlMedia) {
      bodyFormData.append("url_media", urlMedia);
      // si tenor on passe le fichier preview
      if (tenorId && tenorSlug) {
        bodyFormData.append("url_media_preview", fichierPreview);
        bodyFormData.append("url_media_id", tenorId);
      }
    }

    if (props?.id_reponse && props.id_reponse > 0) {
      bodyFormData.append("type", "reponse");
      bodyFormData.append("id_reponse", props.id_reponse);
      bodyFormData.append("idabr", props.id_arbre);
    } else {
      bodyFormData.append("box_permalink", props.box_permalink);
    }

    const options = {
      headers: {
        "Content-Type": "multipart/form-data",
        // "User-Agent": "Choualbox Next",
      },
      onUploadProgress: (progressEvent) => {
        var percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total,
        );
        setPourcentage(percentCompleted);
      },
    };

    axios
      .post(
        process.env.NEXT_PUBLIC_API_URL + "/api/commentaires/poster",
        bodyFormData,
        options,
      )
      .catch(function (error) {
        toast("Erreur de chargement", {
          type: "error",
        });
        setPourcentage(0);
        setLoading(false);
      })
      .then((response) => {
        if (response.data.status === 200) {
          passRefresh(true); // refresh
          setTexte("");
          setFichier(null);
          setFichierPreview(null);
          setNsfw(0);
          setGiphyId(null);
          setGiphySlug(null);
          setTenorId(null);
          setTenorSlug(null);
          setPourcentage(0);
          setUrlMedia(null);

          // toast("Commentaire posté avec succès.", {
          //   type: "success",
          // });

          // si c'est une réponse on retire le form répondre
          // ce code est seulement utile sur la page /m/suivi, dans la box il sert à rien car les commentaires sont refresh
          // if (props?.id_reponse && props.id_reponse > 0) {
          //   passHideReponseForm(true);
          // }

          router.refresh();
        } else {
          toast(response.data.message, {
            type: "error",
          });
        }

        setPourcentage(0);
        setLoading(false);
      });
  };

  // confirmer avant de quitter / changement non enregisrés (pas utilisée mais on le laisse pour plus tard)
  const [changesOnPage, setChangesOnPage] = useState(false);
  useEffect(() => {
    if (texte.length > 0 || fichierPreview || urlMedia) {
      setChangesOnPage(true);
    } else {
      setChangesOnPage(false);
    }
  }, [texte, fichierPreview, urlMedia]);

  return props.userTk ? (
    <>
      {props?.id_reponse && props.id_reponse > 0 && (
        <div className="flex gap-x-1 items-center mb-1 mt-1 text-sm text-base-content/50">
          <MdInfoOutline className="w-4 h-4" />
          Vous répondez à @{props.pseudo_reponse}
        </div>
      )}
      <div className={`flex mb-4 ${loading && "opacity-50"}`}>
        {avatar && !props.id_reponse ? (
          <div className="w-12 relative flex justify-center pr-2 flex-none">
            <img
              src={avatar}
              alt={pseudo}
              width={50}
              height={50}
              className="rounded-full w-10 h-10"
            />
          </div>
        ) : null}{" "}
        <div className="grow">
          <textarea
            placeholder={
              props?.id_reponse && props.id_reponse > 0
                ? "Répondre à " + props.pseudo_reponse
                : "Poster un commentaire"
            }
            className="w-full text-sm text-base-content bg-base-100  border border-base-content/10 p-2 rounded"
            onChange={(e) => {
              setTexte(e.target.value);
            }}
            value={texte}
            ref={refTextarea}
            // autoFocus={props?.id_reponse && props.id_reponse > 0 ? true : false}
          ></textarea>
          <div className="flex">
            {fichierPreview ? (
              <div className="flex">
                <div className="w-22 h-22 relative">
                  <button
                    className="absolute -right-1 -top-1 bg-black text-white rounded-full h-4 w-4 text-xxs flex items-center justify-center border border-white"
                    onClick={() => {
                      setFichier(null);
                      setFichierPreview(null);
                      setGiphyId(null);
                      setGiphySlug(null);
                      setTenorId(null);
                      setTenorSlug(null);
                    }}
                  >
                    <MdClose className="w-2 h-2" />
                  </button>
                  {giphyId && giphySlug ? (
                    <>
                      <picture className="w-full h-full object-cover rounded">
                        <source
                          type="image/webp"
                          srcSet={
                            "https://media3.giphy.com/media/" +
                            giphyId +
                            "/200h.webp"
                          }
                        />
                        <img
                          className="max-w-full"
                          src={
                            "https://media3.giphy.com/media/" +
                            giphyId +
                            "/200h_s.gif"
                          }
                          alt={"GIF"}
                          preload="none"
                        />
                      </picture>
                    </>
                  ) : (
                    <img
                      src={fichierPreview}
                      alt="preview"
                      className="w-full h-full object-cover rounded max-w-sm max-h-48"
                    />
                  )}
                </div>
              </div>
            ) : (
              <>
                <label className={`btn btn-sm no-animation`}>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(event) => {
                      if (event?.target?.files[0]) {
                        setFichier(event.target.files[0]);
                        setFichierPreview(
                          URL.createObjectURL(event.target.files[0]),
                        );
                      } else {
                        setFichier(null);
                        setFichierPreview(null);
                      }
                    }}
                    className="hidden"
                  />
                  <MdCameraAlt className="w-4 h-4 m-auto text-base-content" />
                </label>
                {/* <button
                  onClick={() => {
                    // history.pushState(null, null, "#gif");
                    setShowTenorModal(true);
                  }}
                  className={`ml-2 btn btn-sm no-animation`}
                >
                  <div className="text-xs font-semibold text-base-content m-auto">
                    GIF
                  </div>
                </button> */}
              </>
            )}

            <button
              onClick={() => {
                nsfw == 0 ? setNsfw(1) : setNsfw(0);
              }}
              className={`ml-2 btn btn-sm no-animation ${
                nsfw == 1 ? " btn-secondary " : ""
              }`}
            >
              <div className="text-xs font-semibold text-base-content m-auto">
                NSFW
              </div>
            </button>

            <div className="grow"></div>
            <div className="flex">
              {props?.id_reponse && props.id_reponse > 0 && (
                <button
                  onClick={() => passHideReponseForm(true)}
                  className="mr-2 text-xs text-base-content/50"
                >
                  <div className="sm:hidden">X</div>
                  <div className="hidden sm:block">Annuler</div>
                </button>
              )}
              <input
                onClick={() => poster()}
                type="submit"
                value={
                  props?.id_reponse && props.id_reponse > 0
                    ? "Répondre"
                    : "Commenter"
                }
                className="btn btn-sm btn-primary no-animation truncate"
              />
            </div>
          </div>
        </div>
      </div>
      {showGiphyModal && (
        <GiphyModal
          passShowGiphyModal={() => setShowGiphyModal(false)}
          passGiphyId={(e) => setGiphyId(e)}
          passGiphySlug={(e) => setGiphySlug(e)}
          passGiphyPreviewUrl={(e) => setFichierPreview(e)}
          returnHref={"/" + props.box_permalink}
        />
      )}
      {showTenorModal && (
        <TenorModal
          passShowTenorModal={() => setShowTenorModal(false)}
          passTenorId={(e) => setTenorId(e)}
          passTenorSlug={(e) => setTenorSlug(e)}
          passTenorPreviewUrl={(e) => setFichierPreview(e)}
          returnHref={"/" + props.box_permalink}
          userTk={props.userTk}
        />
      )}
    </>
  ) : (
    <Link className="mb-4 block" href="/m/connexion">
      <div className="w-full text-sm text-base-content bg-base-100  border border-base-content/10 p-2 rounded h-18 cursor-text">
        Poster un commentaire
      </div>
      <div className="flex w-full mt-2">
        <div className="grow"></div>
        <div className="flex">
          <button className="btn btn-sm btn-primary no-animation">
            Commenter
          </button>
        </div>
      </div>
    </Link>
  );
}
